const supportedLanguages = ['en', 'pt', 'es'];

export default supportedLanguages;
